import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
	name: 'maintenanceModeDateTime',
	standalone: true,
})
export class MaintenanceModeDateTimePipe implements PipeTransform {	
	public transform(text: string, start: number | null, end: number | null): string {
		const timezoneToTransform = moment.tz.guess();

		if (start) {
			const timeString = moment(start).tz(timezoneToTransform).format("LT");
			const dateString = moment(start).tz(timezoneToTransform).format("L");
			const startText = dateString + " " + timeString + " " + timezoneToTransform;
			text = text.replace("[start]", `<span class="date-time">${startText}</span>`)
		} else {
			text = text.replace("[start]", ``)
		}

		if (end) {
			const timeString = moment(end).tz(timezoneToTransform).format("LT");
			const dateString = moment(end).tz(timezoneToTransform).format("L");
			const endText = dateString + " " + timeString + " " + timezoneToTransform;
			text = text.replace("[end]", `<span class="date-time">${endText}</span>`)
		} else {
			text = text.replace("[end]", ``)
		}

		return text;
	}
}
